module.exports = __webpack_public_path__ + "images/icons_v2/trash-can-56e1e9a2.svg";